import ModuleWrapper from 'shared-lib/containers/Module';

const Onboarding = () => import(/* webpackChunkName: "onboarding" */ '@/views/onboarding/Onboarding');
const OnboardingDetails = () => import(/* webpackChunkName: "onboarding-details" */ '@/views/onboarding/OnboardingDetails');
const OnboardingForm = () => import(/* webpackChunkName: "onboarding-form" */ '@/views/onboarding/OnboardingForm');
const meta = (data = {}) => ({
    permissionsModuleName: 'onboarding',
    title: 'Onboarding',
    auth: true,
    ...data,
});
import { marketplaceRouteGuard } from '@/router/helpers/routeGuards';

export default [{
    path: 'onboarding',
    component: ModuleWrapper,
    meta: meta({
        permission: 'list',
    }),
    children: [
        {
            path: '',
            name: 'Onboarding',
            component: Onboarding,
            meta: meta({
                permission: 'list',
            }),
            beforeEnter: marketplaceRouteGuard,
        },
        {
            path: ':id(\\d+)/edit',
            name: 'OnboardingEdit',
            component: OnboardingForm,
            props: true,
            meta: meta({
                permission: 'update',
            }),
            beforeEnter: marketplaceRouteGuard,
        },
        {
            path: ':id(\\d+)/approve',
            name: 'OnboardingApprove',
            component: OnboardingForm,
            props: true,
            meta: meta({
                permission: 'approve',
            }),
            beforeEnter: marketplaceRouteGuard,
        },
        {
            path: ':id(\\d+)',
            name: 'OnboardingDetails',
            component: OnboardingDetails,
            props: true,
            meta: meta({
                permission: 'list',
            }),
            beforeEnter: marketplaceRouteGuard,
        },
    ],
}];
